import Loading from './Loading';
import styles from './styles.css';

export {
    Loading,
    styles
}